import type {ComponentStageData, InnerElementStageData, ConversionDal} from '../../types'
import {getStylePointer} from '../../conversionDal/utils/pointer'
import type {StyleEntryItem} from '../../conversionDal/types'
import type {Pointer} from '@wix/document-services-types'
import _ from 'lodash'
import {isCSSVariable} from '../../utils/cssUtils'
// eslint-disable-next-line wix-editor/no-internal-import
import {CSS_PROPERTIES} from '@wix/component-protocol/schema'

const containsSPXSize = (value: string): boolean => {
    const pixelRegex = /(\d+(\.\d+)?)(spx)/
    return pixelRegex.test(value)
}

const filterSPXProperties = (properties: Record<string, string>): Record<string, string> => {
    return _.pickBy(properties, (value: string) => containsSPXSize(value) && !isCSSVariable(value))
}

const resetStyleScalingCore = (
    conversionDal: ConversionDal,
    stylePointer: Pointer,
    baseStyleSettings: StyleEntryItem
) => {
    const filteredCssProperties = filterSPXProperties(
        _.omit(baseStyleSettings?.cssProperties || {}, [
            'font',
            'fontSize',
            ...Object.keys(baseStyleSettings.metaData?.overrides?.cssProperties ?? {})
        ])
    )
    const filteredCssCustomProperties = filterSPXProperties(
        _.omitBy(
            baseStyleSettings?.cssCustomProperties || {},
            (_value: string, key: string) =>
                baseStyleSettings?.metaData?.cssCustomPropertiesInfo?.[key] === CSS_PROPERTIES.CSS_PROPERTY_TYPE.font ||
                baseStyleSettings?.metaData?.cssCustomPropertiesInfo?.[key] ===
                    CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontSize ||
                baseStyleSettings.metaData?.overrides?.cssCustomProperties?.hasOwnProperty(key)
        )
    )

    conversionDal.modify(stylePointer, (value: any) =>
        _.merge({}, value, {
            cssProperties: filteredCssProperties,
            cssCustomProperties: filteredCssCustomProperties
        })
    )
}

export const resetStyleScaling = (componentStageData: ComponentStageData) => {
    const {conversionDal, componentPointer, initialSnapshot} = componentStageData
    const compStylePointer = getStylePointer(componentPointer)
    const baseStyleSettings = initialSnapshot.getValue(compStylePointer) as StyleEntryItem

    resetStyleScalingCore(conversionDal, compStylePointer, baseStyleSettings)
}

export const resetInnerElementStyleScaling = (innerElementStageData: InnerElementStageData) => {
    const {conversionDal, innerElementPointer, initialSnapshot} = innerElementStageData
    const innerElementStylePointer = getStylePointer(innerElementPointer)
    const baseStyleSettings = initialSnapshot.getValue(innerElementStylePointer) as StyleEntryItem

    resetStyleScalingCore(conversionDal, innerElementStylePointer, baseStyleSettings)
}
